module.exports = new __parcel__URL__("favicon-temp-assets.25c6fb39.png").toString();